import { Pipe, PipeTransform } from '@angular/core';
import { TapTypeEnum } from '@app/core/models/journey/enum/tap-type.enum';
import { Tap } from '@app/core/models/journey/tap';
import { environment } from '@env/environment';
import * as moment from 'moment';
import { Duration } from 'moment';

@Pipe({
  name: 'distinctPRTaps',
  pure: true
})
export class DistinctPRTapsPipe implements PipeTransform {

  private isTooClose (date: Date, otherDate: Date, delay: Duration): Boolean {
    let momentDate = moment(date);
    let momentOtherDate = moment(otherDate);
    let diff = moment.duration(momentDate.diff(momentOtherDate));
    return (diff<delay && diff>moment.duration(0));
  }

  /**
   * Return the list of taps to be displayed
   *
   * @param taps - The list to filter
   */
  transform(taps: Tap[]): Tap[] {
    // do not display TAP-PR if performed in less than manipulationErrorDelayInSeconds after the previous one
    const duplicatePRDelay = moment.duration(environment.passenger.journeys.duplicatePRDelay);
    var tapsToPrint : Tap[] = [];
    for (let tap of taps) {
      if (tap.type !== TapTypeEnum.TAP_PR) {
        tapsToPrint.push(tap);
      } else {
        let keepingCurrentTap = true;
        for (let previousTap of taps){
          if (previousTap.type === TapTypeEnum.TAP_PR && this.isTooClose(tap.issueDate, previousTap.issueDate, duplicatePRDelay)) {
            keepingCurrentTap = false;
          }
        }
        if(keepingCurrentTap){
          tapsToPrint.push(tap);
        }
      }
    }
    return tapsToPrint;
  }
}
